import { IAppState } from "src/modules/reducers";

import { IHeaderState } from "./reducer";

export const getHeader = (state: IAppState): IHeaderState => state.header;
